import { IAlertResponse } from 'interfaces/IAlert'
import { enAlert } from './types'

export const updateAlert = (alerts: IAlertResponse[]) => ({
  type: enAlert.UPDATE_ALERT,
  alerts,
})
